const CompareToValidator = () => {
  const require = 'ngModel'

  const scope = { otherModelValue: '=compareTo' }

  const link = (scope, element, attrs, ctrl) => {
    ctrl.$validators.compareTo = (modelValue, viewValue) => modelValue === scope.otherModelValue
    scope.$watch('otherModelValue', () => ctrl.$validate())
  }

  return { require, scope, link }
}

export default CompareToValidator



// WEBPACK FOOTER //
// ./src/app/common/validators/compare-to.validator.js